<template>
    <div class="" style="padding:.2rem 0 8rem 0">

        <div class="order-success">
<!--            <div class="title">报名成功</div>-->
<!--            <div class="desc"><p style="text-align: center">点击下方链接进入活动页</p>-->
<!--            </div>-->
        </div>

        <div v-for="(item,index) in formData.list">
            <van-divider>{{item.title}}</van-divider>
            <div v-if="item.exame_status==1" style="margin-top: 10px; text-align: center">
                <van-button
                        style="width: 3rem ; margin: 0 auto"
                        size="normal"  round v-rblink="{name:'H5' ,query:{ url:item.url }}" >进入考试</van-button>
            </div>
            <van-cell-group  v-if="item.exame_status==3">
                <van-cell
                        input-align="right"
                        title="场次"
                        :value="item.saiqu"
                />
                <van-cell
                        input-align="right"
                        title="报名ID "
                        :value="item.sojumpparm"
                />
                <van-cell
                        input-align="right"
                        title="姓名 "
                        :value="item.name"
                />
                <van-cell
                        input-align="right"
                        title="身份证 "
                        :value="item.num"
                />
                <van-cell
                        input-align="right"
                        title="得分 "
                        :value="item.totalvalue"
                />
                <van-cell
                        input-align="right"
                        title="总分 "
                        :value="item.fullscore"
                />

            </van-cell-group>
            <div v-if="item.exame_status==3" style="margin-top: 10px; text-align: center">
                <van-button
                              style="width: 3rem ; margin: 0 auto"
                              size="normal"  round v-rblink="{name:'H5' ,query:{ url:item.result_url }}" >查看解析</van-button>
            </div>

        </div>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .order-success{
        text-align: center;
        margin: 20px 0 ;
    }
    .order-success .icon{
        background: url(../../../assets/images/icon-order-done.png);
        background-size: 100%;
        width: 75px;
        height: 75px;
        margin: 20px auto 20px auto;

    }
    .order-success .title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
    }
    .order-success .desc{
        padding: 10px;
        text-align: left;
    }
    .order-success .desc p{
        line-height: 26px;
        font-size: 14px;
        color: #333;
        text-align: left;
    }
    .order-success img{
        width: 90%;
        /*height: 120px;*/
        margin: 10px auto;
    }
    .order-success p{
        font-size: 12px;
        color: #999;
    }

    .sai-shuo-li{
        background: #f3f3f3;
        border-radius: 10px;
        margin: 20px 10px ;
        padding: 10px;
    }
    .sai-shuo-li img{
        width: 50px;
        height: 50px;
        border-radius: 6px;
        float: left;
        margin-right: 10px;
    }
    .sai-shuo-li .c{
        width: calc(100% - 80px);
        border-right: 1px solid #00000008 ;
    }
    .sai-shuo-li .c .title{
        font-size: 14px;
        color: #000;
    }
    .sai-shuo-li .c .desc{
        font-size: 12px;
        color: #999;
    }
    .sai-shuo-li .fr{
        width: 70px;
        float: right;
    }
    .sai-shuo-li .btn{
        width: 60px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        text-align: center;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:6px;
        color: #fff;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }



</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
        .use(Switch).use(Button);
    export default {
        name: 'HuiyiExame',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                ltShow:false,
                ltImgSrc:'',
                ltImgName:'',
                ltActions:[{ name: '保存图片' }],
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                formData:{
                    erweiimg:[],
                    video:{
                    },
                    list:[

                    ]
                }
            }
        },
        filters: {},
        mounted() {
            document.title = '进入考试';
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.post('/api/huiyi/examedetail', {
                    id:that.formData.id,
                }, (res) => {
                    // if(res.data.exame_status==1){
                    //     location.replace(res.data.url)
                    // }else{
                    //
                    // }
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },


        }
    }
</script>



// WEBPACK FOOTER //
// HuiyiExame.vue?05da8120